import {useMutation, useQueryClient} from "@tanstack/react-query";

import {errorHandler} from "@/src/modules/core/lib/tanstack-error";

import {VEHICLE_CHECK_QUERY_KEYS} from "../lib/constants";
import {vehicleChecksService} from "../services";
import type {VehicleCheckStatusPayload} from "../types";

type StatusInput = {
  checkId: number;
  payload: VehicleCheckStatusPayload;
};

export function useVehicleCheckStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({checkId, payload}: StatusInput) =>
      vehicleChecksService.updateVehicleCheckStatus(checkId, payload),
    onSuccess: (_result, {checkId}) => {
      void queryClient.invalidateQueries({queryKey: [VEHICLE_CHECK_QUERY_KEYS.detail, checkId]});
      void queryClient.invalidateQueries({queryKey: [VEHICLE_CHECK_QUERY_KEYS.list]});
      void queryClient.invalidateQueries({queryKey: [VEHICLE_CHECK_QUERY_KEYS.infinite]});
    },
    onError: (error) => {
      errorHandler(error);
    },
  });
}
